import Header from "@/components/Header";
import HeroSlider from "@/components/HeroSlider";
import FeaturesSection from "@/components/FeaturesSection";
import ProductsSection from "@/components/ProductsSection";
import AboutUs from "@/components/AboutUs";
import BrandsMarquee from "@/components/BrandsMarquee";
import ContactForm from "@/components/ContactForm";
import PaymentMethods from "@/components/PaymentMethods";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-white/10 md:bg-white/5 backdrop-blur-md">
      <Header />
      <section id="inicio">
        <HeroSlider />
      </section>
      <FeaturesSection />
      <section id="productos">
        <ProductsSection />
      </section>
      <section id="nosotros">
        <AboutUs />
      </section>
      <BrandsMarquee />
      <section id="contacto">
        <ContactForm />
      </section>
      <PaymentMethods />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Index;
